import { useEffect, useState } from 'react'

export const useTimeRemaining = () => {
  const [timeRemaining, setTimeRemaining] = useState(0)

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date()

      const nextHour = new Date(now)
      nextHour.setHours(now.getHours() + 1, 0, 0, 0)

      setTimeRemaining(Math.floor((nextHour.getTime() - now.getTime()) / 1000))
    }

    updateTimer()

    const interval = setInterval(updateTimer, 1000)

    return () => clearInterval(interval)
  }, [])

  return timeRemaining
}
